import type { Theme } from '@mui/material';

export const SYNC_STATUSES = ['fresh', 'delayed', 'stale', 'never'] as const;

export type SyncStatus = (typeof SYNC_STATUSES)[number];

export type SyncStatusIndicatorProps = {
  status: SyncStatus;
  label: string;
  /** Extra detail (exact date, recovery hint) shown on hover and keyboard focus. */
  tooltip?: string;
  'data-testid'?: string;
};

export function syncStatusColor(theme: Theme, status: SyncStatus): string {
  switch (status) {
    case 'fresh':
      return theme.palette.success.main;
    case 'delayed':
      return theme.palette.warning.main;
    case 'stale':
      return theme.palette.error.main;
    case 'never':
      return theme.palette.text.disabled;
  }
}

export function useSyncStatusIndicator(props: SyncStatusIndicatorProps) {
  return {
    hasTooltip: Boolean(props.tooltip),
    isLive: props.status === 'fresh',
  };
}
